import { render, staticRenderFns } from "./OwnerLabel.vue?vue&type=template&id=316dc9c5&scoped=true&"
import script from "./OwnerLabel.vue?vue&type=script&lang=ts&"
export * from "./OwnerLabel.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerLabel.vue?vue&type=style&index=0&id=316dc9c5&prod&scoped=true&lang=css&"
import style1 from "./OwnerLabel.vue?vue&type=style&index=1&id=316dc9c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316dc9c5",
  null
  
)

export default component.exports